import { FC, MouseEventHandler, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UseReactToPrintFn } from "react-to-print";
import { Button, Stack, SxProps, Theme, useTheme } from "@mui/material";
// import { ReactComponent as IconDownload } from "assets/images/download.svg";
import IconDownload from "@mui/icons-material/FileDownloadOutlined";
import { APP_COMPANY_NAME } from "consts";
import { createLDTLink, createRecadzLink, createExcellLink } from "../utils/download-links";
import getStyles from "./styles";

type Props = {
  id?: string;
  pdfUrl: string;
  ldtUrl: string;
  recadzUrl: string;
  requestHash: string;
  pdfLoading?: boolean;
  sx?: SxProps<Theme>;
  reactToPrint: UseReactToPrintFn;
  updateProject: (key: string, value: string) => void;
  carbonePrint?: () => void;
};

const DownloadLinks: FC<Props> = ({ id, pdfUrl, ldtUrl, recadzUrl, requestHash, pdfLoading, sx = {}, reactToPrint, carbonePrint }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).DownloadLinks, [theme]);

  const handlePrint: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    reactToPrint();
  };

  const handleCarbone: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    carbonePrint?.();
  };

  const handleLdt: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    window.location.href = createLDTLink(ldtUrl, lang);
  };

  const handleRecadz: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    window.location.href = createRecadzLink(recadzUrl, lang);
  };

  const handleExcel: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    window.location.href = createExcellLink(requestHash);
  };

  return (
    <Stack id={id} component="section" sx={{ ...styles.buttons, ...sx } as SxProps<Theme>}>
      {pdfUrl !== null && (
        <Button variant="contained" endIcon={<IconDownload />} onClick={handlePrint}>
          {t("Result report (PDF)")}
        </Button>
      )}
      {APP_COMPANY_NAME.toLowerCase() === "relux" && carbonePrint && (
        <Button variant="contained" endIcon={<IconDownload />} disabled={pdfLoading} onClick={handleCarbone}>
          {pdfLoading ? t("Generating...") : t("Download PDF (new)")}
        </Button>
      )}
      {ldtUrl !== "" && (
        <Button variant="contained" endIcon={<IconDownload />} onClick={handleLdt}>
          {t("Download LDT file")}
        </Button>
      )}
      {recadzUrl !== "" && (
        <Button variant="contained" endIcon={<IconDownload />} onClick={handleRecadz}>
          {t("Download RECADz")}
        </Button>
      )}
      <Button variant="contained" endIcon={<IconDownload />} onClick={handleExcel}>
        {t("Download Excel-xml")}
      </Button>
    </Stack>
  );
};

export default DownloadLinks;
